import type { SelectOption } from "@clintonelec/react-storybook";
import {
	BitrateControl, Codec, FirstStreamResolution, FourthStreamResolution, ImageQuality, Profile, SecondStreamResolution,
	ThirdStreamResolution, VideoFormat
} from "Data/Objects/Camera";

export const codecOptions: SelectOption[] = [
	{
		label: Codec.H264,
		value: Codec.H264
	},
	{
		label: Codec.H265,
		value: Codec.H265
	},
	{
		label: Codec.MJPEG,
		value: Codec.MJPEG
	}
];

export const profileOptions: SelectOption[] = [
	{
		label: "Baseline",
		value: Profile.BASELINE
	},
	{
		label: "Main",
		value: Profile.MAIN
	},
	{
		label: "High",
		value: Profile.HIGH
	}
];

export const firstStreamResolutionOptions: SelectOption[] = Object.values(FirstStreamResolution).map(resolution => {
	return {
		label: resolution,
		value: resolution
	};
});

export const secondStreamResolutionOptions: SelectOption[] = Object.values(SecondStreamResolution).map(resolution => {
	return {
		label: resolution,
		value: resolution
	};
});

export const thirdStreamResolutionOptions: SelectOption[] = Object.values(ThirdStreamResolution).map(resolution => {
	return {
		label: resolution,
		value: resolution
	};
});

export const fourthStreamResolutionOptions: SelectOption[] = Object.values(FourthStreamResolution).map(resolution => {
	return {
		label: resolution,
		value: resolution
	};
});

export const frameRateOptions: SelectOption[] = new Array(30).fill(0).map((current, index) => {
	return {
		label: `${ index + 1 }`,
		value: index + 1
	};
});

export const gopSizeOptions: SelectOption[] = new Array(60).fill(0).map((current, index) => {
	return {
		label: `${ index + 1 }`,
		value: index + 1
	};
});

export const bitrateControlOptions: SelectOption[] = [
	{
		label: BitrateControl.CBR,
		value: BitrateControl.CBR
	},
	{
		label: BitrateControl.VBR,
		value: BitrateControl.VBR
	},
	{
		label: BitrateControl.VBRPLUS,
		value: BitrateControl.VBRPLUS
	}
];

export const imageQualityOptions: SelectOption[] = [
	{
		label: "Low",
		value: ImageQuality.LOW
	},
	{
		label: "Mid",
		value: ImageQuality.MID
	},
	{
		label: "High",
		value: ImageQuality.HIGH
	}
];

export const useStreamSettingsOptions: SelectOption[] = [
	{
		label: "Main Stream",
		value: "mainStream"
	},
	{
		label: "Second Stream",
		value: "secondStream"
	}
];

export const fourthStreamFrameRateOptions: SelectOption[] = [
	{
		label: "1/2",
		value: 0.5
	},
	{
		label: "1/4",
		value: 0.25
	}
];

export const videoFormatOptions: SelectOption[] = [
	{
		label: "NTSC - 60 Hz",
		value: VideoFormat.NTSC
	},
	{
		label: "PAL - 50 Hz",
		value: VideoFormat.PAL
	}
];
